module.exports = [{"id":64482,"slug":"body-with-docs","title":"кузов с документами"},{"id":64481,"slug":"entirely-spare-parts","title":"целиком по запчастям"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/partsSellingTypes.json
// module id = 1149
// module chunks = 49